import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useParams, withRouter } from 'react-router-dom';
import { useEffectOnce } from '@guryou/hooks';
import { CenterMediumContent, ContainedButton, DefaultText, Form, FormActions, PasswordBox, SmallText, Spinner } from '@guryou/html-components';
import { cognitoFirstLoginSetPassword, cognitoVerifyUser, StateStatus } from '@guryou/redux';
import { cognitoPasswordRequirements } from '@guryou/utils';
import { persistor } from 'store';
import './main.css';

const defaultState = {
  password: '',
  confirmPassword: '',
};

const VerifyPassword = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [ls, setLs] = useState(defaultState);
  const auth = useSelector(state => state.auth);
  const firstLogin = useSelector(state => state.cognito.firstLogin);
  const { email, code } = useParams();

  useEffectOnce(() => {
    cognitoVerifyUser(email, code).then(user => setLs(o => ({ ...o, user })));
  });

  if (firstLogin.status === StateStatus.LOADING) {
    return <Spinner big={true} />;
  }

  if (auth.status === StateStatus.LOADED && firstLogin.status === StateStatus.LOADED) {
    return <Redirect to={{ pathname: '/management/providers', state: { from: props.location } }} />;
  }

  const handleInputsChange = (value, e, input) => {
    e.persist();
    setLs(prevState => ({ ...prevState, [input]: value }));
  };

  const handleSubmit = async data => {
    const { newPassword } = data;
    dispatch(cognitoFirstLoginSetPassword({ newPassword }, ls.user, persistor));
  };

  const passwordStrength = cognitoPasswordRequirements(ls.password);
  const checkIfPasswordMatch = ls.password === ls.confirmPassword;

  return (
    <CenterMediumContent isPublicContent={false}>
      <Form className="login" onSubmit={handleSubmit} actions={false}>
        <div className="logoBg"></div>
        <DefaultText textAlign="center">{t('CONFIRMATIONS.enterYourNewPassword')}</DefaultText>
        <PasswordBox
          onChange={(value, e) => handleInputsChange(value, e, 'password')}
          name="newPassword"
          label={t('GENERAL.password')}
          autoComplete="current-password"
          required
        />
        <PasswordBox
          onChange={(value, e) => handleInputsChange(value, e, 'confirmPassword')}
          name="confirmPassword"
          label={t('PROFILE.confirmPass')}
          autoComplete="current-password"
          required
        />
        <FormActions>
          <ContainedButton disabled={!!passwordStrength || !checkIfPasswordMatch} color="primary" type="submit" text={t('GENERAL.save')} />
        </FormActions>
        <SmallText padding={2} color="red">
          {firstLogin.error && firstLogin.error.message}
        </SmallText>
        <SmallText padding={2} color="red">
          {passwordStrength && passwordStrength}
        </SmallText>
        <SmallText padding={2} color="red">
          {ls.password.length >= 8 && ls.confirmPassword && !checkIfPasswordMatch && t('ACCOUNT.newAndConfirmPassDontMatch')}
        </SmallText>
      </Form>
    </CenterMediumContent>
  );
};

export default withRouter(VerifyPassword);
